import React from 'react';
import { Chip, alpha } from '@mui/material';
import {
  PriorityHigh as CriticalIcon,
  KeyboardArrowUp as HighIcon,
  Remove as NormalIcon,
  KeyboardArrowDown as LowIcon,
} from '@mui/icons-material';

/**
 * TaskPriorityBadge Component
 * Displays task priority with appropriate color and icon
 */
const TaskPriorityBadge = ({ priority, size = 'small', variant = 'filled' }) => {
  const getPriorityConfig = () => {
    switch (priority) {
      case 'critical':
        return {
          label: 'Critical',
          color: '#d32f2f',
          icon: <CriticalIcon sx={{ fontSize: 14 }} />,
        };
      case 'high':
        return {
          label: 'High',
          color: '#f57c00',
          icon: <HighIcon sx={{ fontSize: 14 }} />,
        };
      case 'normal':
        return {
          label: 'Normal',
          color: '#0078b7',
          icon: <NormalIcon sx={{ fontSize: 14 }} />,
        };
      case 'low':
        return {
          label: 'Low',
          color: '#66bb6a',
          icon: <LowIcon sx={{ fontSize: 14 }} />,
        };
      default:
        return {
          label: priority || 'Normal',
          color: '#0078b7',
          icon: <NormalIcon sx={{ fontSize: 14 }} />,
        };
    }
  };

  const config = getPriorityConfig();

  return (
    <Chip
      icon={config.icon}
      label={config.label}
      size={size}
      variant={variant === 'outlined' ? 'outlined' : undefined}
      sx={{
        backgroundColor: variant === 'filled' ? alpha(config.color, 0.1) : 'transparent',
        color: config.color,
        border: `1px solid ${alpha(config.color, 0.3)}`,
        fontWeight: 600,
        '& .MuiChip-icon': {
          color: config.color,
        },
      }}
    />
  );
};

export default TaskPriorityBadge;
